<template>
  <PageTemplate title="Produto" :class="componentClass" :noContainer="true">
    <v-container class="py-10 py-md-13 py-lg-16">
      <LoadingWidget v-if="loading" />

      <template v-else>
        <v-row>
          <v-col cols="12" md="6">
            <div style="position: sticky; top: 50px" class="mb-10">
              <Gallery
                v-if="img && gallery.length"
                :items="gallery"
                :main="img"
              />
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div style="position: sticky; top: 50px" class="mb-10">
              <TitleWidget :align="'left'" class="mb-5">
                {{ item.title }}
              </TitleWidget>
              <div v-html="item.text"></div>
              <div v-if="featureds" class="featureds">
                <div
                  v-for="(featured, key) in featureds"
                  :key="key"
                  class="featured"
                >
                  <v-icon color="primary">fas fa-check-circle</v-icon>
                  <div>
                    <h4>{{ featured[0] }}</h4>
                    <div>{{ featured[1] }}</div>
                  </div>
                </div>
              </div>
              <ButtonWidget to="/atendimento">Solicite orçamento</ButtonWidget>
            </div>
          </v-col>
        </v-row>
        <div class="product-text">
          <div v-html="item.text2"></div>
        </div>
      </template>
    </v-container>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../../components/templates/PageTemplate.vue";
import ButtonWidget from "../../components/widgets/ButtonWidget.vue";
import LoadingWidget from "../../components/widgets/LoadingWidget.vue";
import TitleWidget from "../../components/widgets/TitleWidget.vue";
import Gallery from "./Gallery.vue";

const _config = {
  mod: "products",
};

const _data = {
  title: "Produtos",
  loading: true,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    img() {
      if (!this.item.img.featured.path) return "";

      return this.files + this.item.img.featured.path;
    },
    gallery() {
      if (!this.item.img.list) return [];

      return this.item.img.list.map(({ path }) => {
        return this.files + path;
      });
    },
    featureds() {
      return JSON.parse(this.item.featureds);
    },
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    componentClass() {
      return "product-item";
    },
  },
  methods: {
    getItem() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({ id: this.itemId, save: (state, data) => (state.item = data) })
        .finally(() => (this.loading = false));
    },
    updateDocumentTitle() {
      document.title = this.item.title;
    },
  },
  watch: {
    $route() {
      this.getItem();
      this.updateDocumentTitle();
    },
    "item.title"(newTitle) {
      if (newTitle) {
        document.title = newTitle;
      }
    },
  },
  created() {
    this.getItem();
    this.updateDocumentTitle();
  },
  components: {
    PageTemplate,
    LoadingWidget,
    Gallery,
    TitleWidget,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.featureds {
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 15px 0;
  margin: 15px 0;

  .featured {
    h4 {
      font-size: 16px;
    }
    display: flex;
    gap: 10px;
    font-size: 14px;
  }
}
</style>
